import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../SEO';
import { useAuth, getDashboardPath } from '../../context/AuthContext';
import { ArrowRight } from 'lucide-react';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(getDashboardPath(user));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SEO title="Portal Login" description="Sign in to the InnovHer accelerator portal." />
      <section className="min-h-screen bg-[#08080a] flex items-center justify-center p-6 pt-24">
        <div className="w-full max-w-md bg-white/[0.02] border border-white/10 p-8 rounded-3xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-[#d42b92]/20 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2" />

          <h1 className="text-3xl font-semibold text-white tracking-tight mb-2 relative z-10">Accelerator Portal</h1>
          <p className="text-white/60 mb-8 relative z-10">Sign in as Admin, Founder, Mentor, or Investor.</p>

          <form onSubmit={handleLogin} className="space-y-5 relative z-10">
            {error && (
              <div className="p-3 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 text-sm">{error}</div>
            )}

            <div>
              <label className="block text-sm text-white/70 mb-2">Email Address</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-white/20 focus:outline-none focus:border-[#d42b92] transition-colors"
                placeholder="you@company.com"
              />
            </div>

            <div>
              <label className="block text-sm text-white/70 mb-2">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-white placeholder:text-white/20 focus:outline-none focus:border-[#d42b92] transition-colors"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full mt-4 flex items-center justify-center gap-2 bg-[#d42b92] hover:bg-[#ff8ec5] text-white py-3.5 rounded-xl font-medium transition-colors disabled:opacity-50"
            >
              {loading ? 'Authenticating...' : 'Sign In'} <ArrowRight className="w-4 h-4" />
            </button>
            <p className="text-center text-sm text-white/50 mt-4">
              <a href="/forgot-password" className="text-[#ff8ec5] hover:underline">Forgot password?</a>
            </p>
          </form>
        </div>
      </section>
    </>
  );
}
